import { makeStyles } from '@material-ui/core';
import Theme from '../views/ui/Theme';
const useStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    // alignItems: "stretch",
    // height: "auto",
    maxHeight: '100vh',
    // position: "fixed",
    maxWidth: '100%',
    overflowY: 'hidden',
    overflowX: 'scroll',
    // backgroundColor: "red",
  },
  toastSuccess: {
    background: '#027A48',
  },
  sidebar: {
    width: '20.5vw',
    marginRight: '40px',
    display: 'flex',
    flexDirection: 'column',
  },
  sidebarDose: {
    width: '279px',
    height: '91vh',
    background: '#FFFFFF',
    boxShadow: '0px 0px 16px rgba(0, 0, 0, 0.1)',
  },
  sidebar2: {
    marginTop: '2px',
    height: '45vh',
    width: '279px',
    overflowY: 'auto',
    overflowX: 'hidden',
    '&::-webkit-scrollbar': { width: '10px' },
    '&::-webkit-scrollbar-track': {
      boxShadow: 'inset 0 0 5px grey',
      borderRadius: '20px',
    },
    '&::-webkit-scrollbar-thumb': {
      background: 'lightGrey',
      borderRadius: '100px',
    },
  },
  tabBar1: {
    maxHeight: '30vh',
    width: '267px',
    overflowY: 'auto',
    overflowX: 'hidden',
    '&::-webkit-scrollbar': { width: '10px' },
    '&::-webkit-scrollbar-track': {
      boxShadow: 'inset 0 0 5px grey',
      borderRadius: '20px',
    },
    '&::-webkit-scrollbar-thumb': {
      background: 'lightGrey',
      borderRadius: '100px',
    },
  },
  searchBar: {
    maxHeight: '5vh',
    margin: '10px 0',
  },
  sidebarCategory: {
    height: '50vh',
    width: '279px',
    '&::-webkit-scrollbar': { width: '10px' },
    '&::-webkit-scrollbar-track': {
      boxShadow: 'inset 0 0 5px grey',
      borderRadius: '20px',
    },
    '&::-webkit-scrollbar-thumb': {
      background: 'lightGrey',
      borderRadius: '100px',
    },
  },
  sidebar3: {
    maxHeight: '50vh',
    width: '279px',
    overflowY: 'auto',
    overflowX: 'hidden',
    '&::-webkit-scrollbar': { width: '10px' },
    '&::-webkit-scrollbar-track': {
      boxShadow: 'inset 0 0 5px grey',
      borderRadius: '20px',
    },
    '&::-webkit-scrollbar-thumb': {
      background: 'lightGrey',
      borderRadius: '100px',
    },
  },
  sidebarDealership: {
    display: 'flex',
    flexDirection: 'column',
    height: '54vh',
    overflowY: 'auto',
  },
  mainContent: {
    width: '73%',
  },
  topbar: {
    top: '0',
    marginRight: '13px',
    maxHeight: '16vh',
  },
  middleContent: {
    marginRight: '13px',
  },
  bodyContent: {
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    // overflow: "scroll",
  },
  leftbar: {
    // float: "left",
    // display: "inline",
    width: '380px',
    height: 'auto',
    maxHeight: '60%',
    border: '2px solid, black',
    overflow: 'auto',
    '&::-webkit-scrollbar': { width: '10px' },
    '&::-webkit-scrollbar-track': {
      boxShadow: 'inset 0 0 5px grey',
      borderRadius: '20px',
    },
    '&::-webkit-scrollbar-thumb': {
      background: 'lightGrey',
      borderRadius: '100px',
    },
    marginRight: '1%',

    // backgroundColor: "blue",
  },
  leftbarScroll: {
    maxHeight: '68vh',
    overflowY: 'auto',
    '&::-webkit-scrollbar': { width: '10px' },
    '&::-webkit-scrollbar-track': {
      boxShadow: 'inset 0 0 5px grey',
      borderRadius: '20px',
    },
    '&::-webkit-scrollbar-thumb': {
      background: 'lightGrey',
      borderRadius: '100px',
    },
  },
  rightbar: {
    width: '100%',
    marginLeft: '13px',
    marginRight: '13px',
  },
  rightbar1: { height: '6vh', backgroundColor: 'white', display: 'flex', alignItems: 'space-between', width: '100%' },
  rightbar2: {
    // marginTop: "50px",
    height: '63vh',
    // overflowY: 'auto',
    // overflowX: 'hidden',
    // width: '41.5vw',
    // '&::-webkit-scrollbar': { width: '10px' },
    // '&::-webkit-scrollbar-track': {
    //   boxShadow: 'inset 0 0 5px grey',
    //   borderRadius: '20px',
    // },
    // '&::-webkit-scrollbar-thumb': {
    //   background: 'lightGrey',
    //   borderRadius: '100px',
    // },
  },
  searchFrame: {
    width: '100%',
    height: '42px',
    background: Theme.palette.secondary.main,
    marginLeft: '20px',
    marginTop: '20px',
  },
  searchText: {
    width: '100%',
    height: '42px',
    background: '#FAFAFA',
    border: '2px solid #E2E2E2',
    padding: '8px',
    fontFamily: 'Montserrat',
    fontWeight: '500',
    fontSize: '14px',
  },
  featherPlus: {
    width: '48px',
    height: '42px',
    background: '#FAFAFA',
  },
  featherPlusSelected: {
    width: '48px',
    height: '42px',
    background: '#D3D3D3',
  },
  collectionSelected: {
    height: '42px',
    background: '#622FEE',
    justifyContent: 'center',
    alignItems: 'center',
  },
  menuPlusButton: {
    border: `1px solid ${Theme.palette.secondary.main}`,
    backgroundColor: Theme.palette.secondary.main,
    borderRadius: '0',
    fontStyle: 'normal',
    fontSize: '28px',
    fontWeight: 200,
    lineHeight: '25px',
    color: 'rgba(0, 0, 0, 0.4)',
    height: '50px',
    padding: '15px',
    cursor: 'pointer',
  },
  menuList: {
    border: `1px solid ${Theme.palette.secondary.main}`,
    borderRadius: '0',
    height: '100px',
    width: 'inherit',
  },
  menuListCG: {
    border: `1px solid ${Theme.palette.secondary.main}`,
    borderRadius: '0',
    height: '50px',
    width: 'inherit',
  },
  fullWidth: {
    width: '100%',
    padding: '6px 16px 6px 16px',
  },
  sidebarBox: {
    flexGrow: '0',
    maxWidth: '23%',
    marginRight: '2%',
    '@media (min-width: 1024px)': {
      flexGrow: '0',
      maxWidth: '23%',
      marginRight: '5%',
    },
    '@media (min-width:1439px)': {
      flexGrow: '0',
      maxWidth: '23%',
      marginRight: '2%',
    },
  },
}));

export default useStyles;
